import { render, staticRenderFns } from "./CameraPageShootCardAutoDriversLicenseDiagonal2.vue?vue&type=template&id=7e20d5e7&"
import script from "./CameraPageShootCardAutoDriversLicenseDiagonal2.vue?vue&type=script&lang=ts&"
export * from "./CameraPageShootCardAutoDriversLicenseDiagonal2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports